export function Intro() {
    return (
        <p className="text-sm text-gray-500">These notifications are sent to the user's mobile device and can be scheduled by setting the <em>send at</em> time.</p>
    );
}

export default Intro;